var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-row',[_c('el-col',{staticClass:"main-wrapper",attrs:{"span":24}},[_c('SidebarComponent'),_c('section',{staticClass:"content-container"},[_c('transition',{attrs:{"name":"el-fade-in-linear","mode":"out-in"}},[_c('router-view',{key:_vm.$route.path})],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }